import { render, staticRenderFns } from "./NewsletterTableView.vue?vue&type=template&id=20058a0f&"
import script from "./NewsletterTableView.vue?vue&type=script&lang=js&"
export * from "./NewsletterTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports